var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

import * as React from 'react';

import LinkButton from './LinkButton';

var LinkPrimaryButton = function LinkPrimaryButton(_ref) {
    var _ref$className = _ref.className,
        className = _ref$className === undefined ? '' : _ref$className,
        rest = _objectWithoutProperties(_ref, ['className']);

    return React.createElement(LinkButton, _extends({ className: 'btn-primary ' + className }, rest));
};

LinkPrimaryButton.propTypes = {
    children: PropTypes.node.isRequired,
    className: PropTypes.string
};
export default LinkPrimaryButton;
import PropTypes from 'prop-types';